<template>
    <v-expansion-panel>
        <v-expansion-panel-header :key="showReload" class="mt-2">
            POS
            <template v-slot:actions>
                <v-btn @click.native.stop="reload()" icon small>
                    <v-icon color="primary">mdi-reload</v-icon>
                </v-btn>
                <!--v-icon color="error" @click="$store.dispatch('deleteWindowByUuid',{uuid : win.uuid})">
                    mdi-close
                </v-icon-->
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-tabs v-model="tab" background-color="primary" dark  >
                <v-tab v-if="$store.getters['rolesUser/getCustomRole'](4) && TipoPlan != 'Contabilidad'"
                    href="#tab-1" @click="changeTab('tab-1')">
                    GENERAR FACTURAS
                </v-tab>

                <v-tab v-if="$store.getters['rolesUser/getCustomRole'](24)  && TipoPlan != 'Contabilidad'"
                 href="#tab-2" @click="changeTab('tab-2')">
                    HISTORIAL DE FACTURAS
                </v-tab>

                <v-tab  v-if="$store.getters['rolesUser/getCustomRole'](13)  && TipoPlan != 'Contabilidad'"
                 href="#tab-3" @click="changeTab('tab-3')">
                    LISTO PARA FACTURAR
                </v-tab>

                <v-tab v-if="keymaster === '47770e9a83f6f46af2a3d2b93fff710a' && $store.getters['rolesUser/getCustomRole'](270)  && TipoPlan != 'Contabilidad'"
                 href="#tab-9" @click="changeTab('tab-9')">
                    FACTURAS R2
                </v-tab>

                <v-tab  v-if="$store.getters['rolesUser/getCustomRole'](68)  && !disabledByPlan(['Contabilidad', 'Ecoanual CONAMYPE'])"
                 href="#tab-4" @click="changeTab('tab-4')">
                    PLANTILLAS DE FACTURACIÓN
                </v-tab>

                <v-tab  v-if="$store.getters['rolesUser/getCustomRole'](71)  && !disabledByPlan(['Contabilidad', 'Ecoanual', 'Ecoanual CONAMYPE'])"
                    href="#tab-5" @click="changeTab('tab-5')">
                    COTIZACIONES
                </v-tab>
                <v-tab v-if="$store.getters['rolesUser/getCustomRole'](67)  && !disabledByPlan(['Contabilidad', 'Ecoanual', 'Ecoanual CONAMYPE'])"
                    href="#tab-6" @click="changeTab('tab-6')">
                    CORTE DE CAJA
                </v-tab>
                <v-tab v-if="IsFinance && $store.getters['rolesUser/getCustomRole'](260)  && !disabledByPlan(['Contabilidad', 'Ecoanual', 'Ecoanual CONAMYPE'])"
                    href="#tab-7" @click="changeTab('tab-7')">
                    FINANCIAMIENTOS A CUOTAS
                </v-tab>

                <v-tab v-if="$store.getters['rolesUser/getCustomRole'](24)"
                    href="#tab-8" @click="changeTab('tab-8')">
                    DESCARGAS DE FACTURA
                </v-tab>

                <v-tab
                    v-if="!disabledByPlan(['Contabilidad', 'Ecoanual', 'Ecoanual CONAMYPE'])"
                    href="#tab-9" @click="changeTab('tab-9') ">
                    LIQUIDACIONES
                </v-tab>

                <v-tab
                    v-if="!disabledByPlan(['Contabilidad', 'Ecoanual', 'Ecoanual CONAMYPE'])"
                    href="#tab-10" @click="changeTab('tab-10')">
                    IMPORTACIÓN DE BOLETOS DE AVIÓN
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
                <v-tab-item value="tab-1">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](4)" flat>
                        <v-card-text class="px-3 pt-3 pb-0" v-if="canUseGenerateInvoices">
                            <v-row align="center">
                                <v-col cols="12" md="4"></v-col>
                                <v-col cols="12" md="4" class="d-flex justify-center align-center py-0" v-if="showSwitchPOS && canUseGenerateInvoices">
                                    <v-switch
                                        v-model="useRestaurantPOS"
                                        inset
                                        dense
                                        label="Usar Restaurant POS"
                                        class="mt-0 mb-0"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="4" class="d-flex justify-center align-center py-0">
                                </v-col>
                                <v-col cols="12" md="4"></v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text :key="reloadCreate" class="px-1 py-1">
                            <template v-if="canUseGenerateInvoices">
                                <Create
                                    v-if="!useRestaurantPOS"
                                    :key="'create-' + reloadNumber"
                                    :win="win"
                                    :has-active-cash-opening="hasActiveCashOpening"
                                    @open-cash-control="cashControlDialog = true"
                                    @open-cash-opening="cashOpeningDialog = true"
                                ></Create>
                                <RestaurantPOS
                                    v-else
                                    :key="'restaurant-' + reloadNumber"
                                    :win="win"
                                    :has-active-cash-opening="hasActiveCashOpening"
                                    @open-cash-control="cashControlDialog = true"
                                    @open-cash-opening="cashOpeningDialog = true"
                                ></RestaurantPOS>
                            </template>
                            <v-card v-else flat class="cash-opening-screen">
                                <v-card-text class="cash-opening-screen__body">
                                    <div class="cash-opening-screen__panel">
                                        <div class="cash-opening-screen__title">Apertura de caja</div>
                                        <div class="cash-opening-screen__subtitle">
                                            Registre el fondo inicial para habilitar GENERAR FACTURAS
                                        </div>

                                        <v-alert v-if="cashOpeningInlineError" type="error" dense outlined class="mb-4">
                                            {{ cashOpeningInlineError }}
                                        </v-alert>
                                        <v-alert v-if="cashOpeningInlineSuccess" type="success" dense outlined class="mb-4">
                                            {{ cashOpeningInlineSuccess }}
                                        </v-alert>

                                        <v-text-field
                                            v-model="cashOpeningInlineForm.OpeningAmount"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            label="Fondo inicial caja chica"
                                            class="cash-opening-screen__field"
                                        ></v-text-field>

                                        <div class="cash-opening-screen__actions">
                                            <v-btn
                                                color="success"
                                                class="mr-3"
                                                :loading="cashOpeningInlineLoading"
                                                @click="openCashInline"
                                            >
                                                Aperturar caja
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="grey darken-1"
                                                :disabled="cashOpeningInlineLoading"
                                                @click="cancelInlineCashOpening"
                                            >
                                                Cancelar
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-2">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](24)" flat class="mt-4">
                        <v-card-text :key="reloadHistory" class="px-1 py-1 mt-2">
                            <History :key="reloadNumber" :win="win"></History>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-3">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](13)" flat class="mt-2">
                        <v-card-text :key="reloadBill" class="px-1 py-1">
                            <Bill v-if="tab === 'tab-3'" :key="reloadNumber" :win="win"></Bill>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-9">
                    <v-card v-if="keymaster === '47770e9a83f6f46af2a3d2b93fff710a' && $store.getters['rolesUser/getCustomRole'](270)" flat class="mt-2">
                        <v-card-text :key="reloadBill" class="px-1 py-1">
                            <HistoryR2 :key="reloadNumber" :win="win"></HistoryR2>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-4">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](68)" flat class="mt-2">
                        <v-card-text :key="reloadTemplateBill" class="px-1 py-1">
                            <TemplateBill :key="reloadNumber" :win="win"></TemplateBill>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-5">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](71)" flat class="mt-0">
                        <v-card-text :key="reloadQuotesBill" class="px-1 py-1">
                            <QuotesBill :key="reloadNumber" :win="win"></QuotesBill>
                        </v-card-text>    
                    </v-card>
                </v-tab-item>
                
                <v-tab-item value="tab-6">
                    <v-card  v-if="$store.getters['rolesUser/getCustomRole'](67)" flat class="my-1">
                        <v-card-text :key="reloadCashierCut" class="px-1 py-1">
                            <CashierCut
                                :key="reloadNumber"
                                :win="win"
                                :external-cash-opening-status="cashOpeningStatus"
                            ></CashierCut>
                        </v-card-text>    
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-7">
                    <v-card>
                        <v-card-text :key="reloadFinanceBill" class="px-1 py-1">
                            <FinanceBill :key="reloadNumber" :win="win"></FinanceBill>
                        </v-card-text>    
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-8">
                    <v-card v-if="$store.getters['rolesUser/getCustomRole'](24)" flat class="mt-4">
                        <v-card-text :key="reloadDownloadInvoices" class="px-1 py-1 mt-2">
                            <DownloadInvoices :key="reloadNumber" :win="win"></DownloadInvoices>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-9">
                    <v-card flat class="mt-4">
                        <v-card-text :key="reloadLiquidaciones" class="px-1 py-1 mt-2">
                            <Liquidaciones :key="reloadNumber" :win="win"></Liquidaciones>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item value="tab-10">
                    <v-card flat class="mt-4">
                        <v-card-text class="px-1 py-1 mt-2">
                            <ImportAirlineTickets :win="win"></ImportAirlineTickets>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>

            <cash-opening-modal
                :value="isCashOpeningModalVisible"
                :status="cashOpeningStatus"
                :strict-cash-closing="cashOpeningStatus.strictCashClosing"
                :hide-close-button="false"
                :target-opening-id="cashOpeningDialogTargetOpeningId"
                :opening-override="cashOpeningDialogOpeningOverride"
                @input="handleCashOpeningDialogInput"
                @status-updated="handleCashOpeningStatusUpdated"
            ></cash-opening-modal>

            <cash-control-modal
                :value="cashControlDialog"
                :status="cashOpeningStatus"
                @input="cashControlDialog = $event"
                @status-updated="handleCashOpeningStatusUpdated"
            ></cash-control-modal>

            <v-dialog v-model="pointSaleSwitchConfirmDialog" max-width="520">
                <v-card>
                    <v-card-title class="text-h6">
                        Confirmar cambio de punto de venta
                    </v-card-title>
                    <v-card-text>
                        <div class="mb-4">
                            Tiene una caja abierta en el punto de venta
                            <strong>{{ pointSaleSwitchPendingData?.pointSale || '-' }}</strong>.
                            Para aperturar en este nuevo punto de venta primero se cerrara la anterior.
                        </div>
                        <v-checkbox
                            v-model="pointSaleSwitchConfirmChecked"
                            dense
                            hide-details
                            label="Estoy seguro que deseo cerrar la caja del otro punto de venta"
                        ></v-checkbox>
                    </v-card-text>
                    <v-card-actions class="px-6 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelPointSaleSwitchConfirmation">
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="success"
                            :disabled="!pointSaleSwitchConfirmChecked || cashOpeningInlineLoading"
                            :loading="cashOpeningInlineLoading"
                            @click="confirmPointSaleSwitchAndOpen"
                        >
                            Cerrar y aperturar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import { mapState } from 'vuex';
import Create from "./create/Create";
import RestaurantPOS from "./RestaurantPOS/RestaurantPOS2";
import History from "./History";
import Bill from "./Bill";
import TemplateBill from './TemplateBill';
import QuotesBill from './QuotesBill';
import CashierCut from './CashierCut';
import FinanceBill from './FinanceBill.vue';
import HistoryR2 from './HistoryR2.vue';
import DownloadInvoices from './DownloadInvoices.vue';
import Liquidaciones from './Liquidaciones.vue';
import ImportAirlineTickets from './ImportAirlineTickets.vue';
import CashOpeningModal from './CashOpeningModal.vue';
import CashControlModal from './CashControlModal.vue';
import { VUE_APP_ENV } from "../../config";

function getStoredUser() {
    try {
        return JSON.parse(localStorage.getItem("user")) || {};
    } catch (error) {
        return {};
    }
}

function isMypeEnabled(value) {
    if (value === undefined || value === null || value === "") {
        return false;
    }

    if (typeof value === "boolean") {
        return value;
    }

    return ["1", "true"].includes(String(value).trim().toLowerCase());
}

function getCurrentPointSale() {
    return localStorage.getItem("codPointSale") || null;
}

export default {
    name: "Invoices",
    components: { Create, RestaurantPOS, History, Bill, TemplateBill, QuotesBill, CashierCut, FinanceBill, HistoryR2, DownloadInvoices, Liquidaciones, ImportAirlineTickets, CashOpeningModal, CashControlModal },
    props: ['win'],
    data() {
        const storedUser = getStoredUser();
        return {
            tabData: null,
            useRestaurantPOS: false,
            showSwitchPOS: false,
            items: [
                { tab: this.$t('vwinvoices_generateinvoices'), content: 'Create' },
                { tab: this.$t('vwinvoices_invoiceshistory'), content: 'History' },
                { tab: this.$t('vwinvoices_readytobill'), content: 'Bill' },
                { tab: "PLANTILLAS DE FACTURACIÃ“N", content: 'TemplateBill' },
                { tab: "COTIZACIONES", content: 'QuotesBill' },
                { tab: "HISTORIAL DE VENTAS", content: 'SalesHistory' },
                { tab: "CORTE DE CAJA", content: 'CashierCut' },
                { tab: "FINANCIAMIENTOS A CUOTAS", content: 'FinanceBill' },
                { tab: "DESCARGAS DE FACTURA", content: 'DownloadInvoices' },
            ],
            tab: null,
            reloadNumber: 0,
            showReload: true,
            IsFinance: storedUser.isfinance,
            keymaster: storedUser.keymaster,
            businessNewUIPOS: storedUser.usenewposrestaurant || 0,
            TipoPlan: storedUser.TipoPlan || null,
            cashOpeningDialog: false,
            cashControlDialog: false,
            cashOpeningStatusLoaded: false,
            cashOpeningInlineLoading: false,
            cashOpeningInlineError: "",
            cashOpeningInlineSuccess: "",
            cashOpeningInlineForm: {
                OpeningAmount: null,
            },
            pointSaleSwitchConfirmDialog: false,
            pointSaleSwitchConfirmChecked: false,
            pointSaleSwitchPendingData: null,
            cashOpeningDialogTargetOpeningId: null,
            cashOpeningDialogOpeningOverride: null,
            reopenAfterCrossPointSaleClose: false,
            cashOpeningStatus: {
                requireCashOpening: Boolean(
                    storedUser.requireCashOpening ||
                    storedUser.RequireCashOpening
                ),
                strictCashClosing: Boolean(
                    storedUser.strictCashClosing ||
                    storedUser.StrictCashClosing
                ),
                pointSale: getCurrentPointSale() || storedUser.pointsale || null,
                activeOpening: null,
            },
        }
    },
    computed: {
        ...mapState('posData', {
            tabState: state => state.currentView,
            reloadCreate: state => state.reloaders.reloadCreate,
            reloadHistory: state => state.reloaders.reloadHistory,
            reloadBill: state => state.reloaders.reloadBill,
            reloadTemplateBill: state => state.reloaders.reloadTemplateBill,
            reloadQuotesBill: state=> state.reloaders.reloadQuotesBill,
            reloadCashierCut: state=> state.reloaders.reloadCashierCut,
            reloadFinanceBill: state=> state.reloaders.reloadFinanceBill,
            reloadDownloadInvoices: state=> state.reloaders.reloadDownloadInvoices,
            reloadLiquidaciones: state=> state.reloaders.reloadLiquidaciones
        }),
        ...mapState({
            currentCodPointSale: state => state.CurrentCodPointSale
        }),
        ...mapState(
            "rolesUser",
            {
                rolesStatus: (state) => state.roles,
            }), 
        headerStore() {
            return this.$store.state.posData.header
        },
        NDorNCStore() {
            return this.$store.state.posData.ndornc
        },
        isMype() {
            return isMypeEnabled(getStoredUser().ismype);
        },
        showNewPOS(){
           // const uiPOS = ['0636d70779280489c228f2bd3aa0ff95', 'c0a0d3ecfce39adf47d6f8dba14e59d2'].includes(this.keymaster);
           if (this.isMype)
            return true;
        
            const uiPOS = this.businessNewUIPOS;
            if(!this.headerStore && !this.NDorNCStore && uiPOS)
            return true; //Cuando sea nuevo

            return  (!this.NDorNCStore
                    && this.headerStore?.InvoiceType 
                    && ['CCF', 'FCF'].includes(this.headerStore?.InvoiceType) //Cuando se copia / reenvio / Guardado un CCF y FCF
                    && uiPOS)
        },
        requiresCashOpening() {
            return Boolean(this.cashOpeningStatus?.requireCashOpening);
        },
        hasStrictCashClosing() {
            return Boolean(this.cashOpeningStatus?.strictCashClosing);
        },
        hasActiveCashOpening() {
            return Boolean(this.cashOpeningStatus?.activeOpening);
        },
        isCashOpeningModalVisible() {
            return this.cashOpeningDialog;
        },
        canUseGenerateInvoices() {
            if (!this.cashOpeningStatusLoaded) {
                return false;
            }
            return !this.requiresCashOpening || this.hasActiveCashOpening;
        }
           

        },
    watch: {
        tabState: {
            immediate: true,
            handler() {
                this.tab = this.tabState || 'tab-1'
            }
        },
        showNewPOS: {
            immediate: true,
            handler(newVal) {
                this.useRestaurantPOS = newVal;
            }
        },
        currentCodPointSale(newValue) {
            this.cashOpeningStatus.pointSale = newValue || getCurrentPointSale() || null;
            this.cashOpeningDialog = false;
            this.cashControlDialog = false;
            this.clearInlineCashOpeningMessages();
            this.fetchCashOpeningStatus();
        }
    },
    async mounted(){
        this.tab = this.tabState || 'tab-1';
        this.useRestaurantPOS = this.showNewPOS;
        this.showSwitchPOS = this.businessNewUIPOS == 1;
        if (VUE_APP_ENV == 1) {
            this.showSwitchPOS = true;
        }
        if (this.isMype) {
            this.showSwitchPOS = false;
        }
        await this.fetchCashOpeningStatus();
    },
    methods: {
        disabledByPlan(arrayPlan = []){
            return arrayPlan.includes(this.TipoPlan) 
        },
        clearInlineCashOpeningMessages() {
            this.cashOpeningInlineError = "";
            this.cashOpeningInlineSuccess = "";
        },
        getFallbackTabAfterCashOpeningBlock() {
            if (this.$store.getters['rolesUser/getCustomRole'](24) && this.TipoPlan != 'Contabilidad') {
                return 'tab-2';
            }
            if (this.$store.getters['rolesUser/getCustomRole'](13) && this.TipoPlan != 'Contabilidad') {
                return 'tab-3';
            }
            if (this.$store.getters['rolesUser/getCustomRole'](68) && this.TipoPlan != 'Contabilidad') {
                return 'tab-4';
            }
            if (this.$store.getters['rolesUser/getCustomRole'](71) && this.TipoPlan != 'Contabilidad') {
                return 'tab-5';
            }
            if (this.$store.getters['rolesUser/getCustomRole'](67) && this.TipoPlan != 'Contabilidad') {
                return 'tab-6';
            }
            if (this.IsFinance && this.$store.getters['rolesUser/getCustomRole'](260) && this.TipoPlan != 'Contabilidad') {
                return 'tab-7';
            }
            if (this.$store.getters['rolesUser/getCustomRole'](24)) {
                return 'tab-8';
            }
            if (this.TipoPlan != 'Contabilidad') {
                return 'tab-9';
            }
            return null;
        },
        async fetchCashOpeningStatus() {
            try {
                const response = await this.$API.cashOpening.getStatus();
                const status = response?.data || {};
                const currentPointSale = status.pointSale || getCurrentPointSale() || this.cashOpeningStatus.pointSale;

                this.cashOpeningStatus = {
                    requireCashOpening: Boolean(status.requireCashOpening),
                    strictCashClosing: Boolean(status.strictCashClosing),
                    pointSale: currentPointSale,
                    activeOpening: status.activeOpening || null,
                };
            } catch (error) {
                console.error('fetchCashOpeningStatus', error);
            } finally {
                this.cashOpeningStatusLoaded = true;
            }
        },
        async ensureCashOpeningAccess() {
            await this.fetchCashOpeningStatus();
        },
        async openCashInline() {
            await this.submitInlineCashOpening(false);
        },
        async submitInlineCashOpening(forceCloseOtherPointSale = false) {
            this.clearInlineCashOpeningMessages();
            this.cashOpeningInlineLoading = true;
            try {
                const response = await this.$API.cashOpening.openCash({
                    ...this.cashOpeningInlineForm,
                    ForceCloseOtherPointSale: forceCloseOtherPointSale,
                });
                this.cashOpeningInlineSuccess = response?.message || "Caja aperturada correctamente";
                this.cashOpeningInlineForm.OpeningAmount = null;
                this.cancelPointSaleSwitchConfirmation();
                await this.handleCashOpeningStatusUpdated();
            } catch (error) {
                if (error?.response?.data?.code === "OTHER_POINT_SALE_OPENING_ACTIVE") {
                    this.pointSaleSwitchPendingData = error.response.data.data || null;
                    this.pointSaleSwitchConfirmChecked = false;
                    this.pointSaleSwitchConfirmDialog = true;
                    return;
                }
                this.cashOpeningInlineError = error?.response?.data?.message || error?.message || "No se pudo aperturar la caja";
            } finally {
                this.cashOpeningInlineLoading = false;
            }
        },
        cancelPointSaleSwitchConfirmation() {
            this.pointSaleSwitchConfirmDialog = false;
            this.pointSaleSwitchConfirmChecked = false;
            this.pointSaleSwitchPendingData = null;
        },
        async confirmPointSaleSwitchAndOpen() {
            if (!this.pointSaleSwitchConfirmChecked) {
                return;
            }
            this.cashOpeningDialogTargetOpeningId = this.pointSaleSwitchPendingData?.openingId || null;
            this.cashOpeningDialogOpeningOverride = this.pointSaleSwitchPendingData || null;
            this.reopenAfterCrossPointSaleClose = true;
            this.pointSaleSwitchConfirmDialog = false;
            this.cashOpeningDialog = true;
        },
        cancelInlineCashOpening() {
            this.clearInlineCashOpeningMessages();
            this.cashOpeningInlineForm.OpeningAmount = null;
            this.cancelPointSaleSwitchConfirmation();
            this.resetCrossPointSaleClosingFlow();
            const fallbackTab = this.getFallbackTabAfterCashOpeningBlock();
            if (fallbackTab) {
                this.tab = fallbackTab;
                this.$store.commit('posData/changeView', fallbackTab);
            }
        },
        handleCashOpeningDialogInput(value) {
            this.cashOpeningDialog = value;
            if (!value) {
                this.resetCrossPointSaleClosingFlow();
            }
        },
        async handleCashOpeningStatusUpdated(event = null) {
            await this.fetchCashOpeningStatus();
            if (event?.action === "closed" && this.reopenAfterCrossPointSaleClose) {
                this.cashOpeningDialog = false;
                this.resetCrossPointSaleClosingFlow();
                await this.submitInlineCashOpening(false);
                return;
            }
            if (this.hasActiveCashOpening) {
                this.clearInlineCashOpeningMessages();
                this.cashOpeningDialog = false;
                this.resetCrossPointSaleClosingFlow();
            }
            if (!this.hasActiveCashOpening) {
                this.cashControlDialog = false;
            }
        },
        resetCrossPointSaleClosingFlow() {
            this.cashOpeningDialogTargetOpeningId = null;
            this.cashOpeningDialogOpeningOverride = null;
            this.reopenAfterCrossPointSaleClose = false;
        },
        generateInvoice() {
            this.tabData = 0;
        },
        reload() {
            //this.$store.commit('posData/setReloaders', 'reloadCreate')
            //this.$store.commit('posData/setReloaders', 'reloadHistory')
            //this.$store.commit('posData/setReloaders', 'reloadBill')
            this.$store.commit("posData/setHeader", null);
            this.$store.commit("posData/setBody", null);
            this.$store.commit("posData/setCustomer", null);
            this.$store.commit("posData/setInvalid", null);
            this.$store.commit("posData/setNDorNC", null);
            this.$store.commit("posData/setQuote", null);
            this.$store.commit("posData/setContingency", null);
            this.$store.commit("posData/setCopy", null);
            this.$store.commit("posData/setForceBlocking", null);
            this.reloadNumber++
            this.showReload = true
        },
        async changeTab(tab) {
            this.$store.commit('posData/changeView', tab)
            this.tab = tab
            if (tab === 'tab-1') {
                await this.ensureCashOpeningAccess();
            }
        }

    }
}
</script>

<style scoped>
.cash-opening-inline-card {
    width: 100%;
    max-width: 340px;
    background: #ffffff !important;
    opacity: 1 !important;
}

.cash-opening-screen {
    background: transparent !important;
    box-shadow: none !important;
}

.cash-opening-screen__body {
    padding: 22px 18px 12px 18px !important;
}

.cash-opening-screen__panel {
    width: 100%;
    min-height: 320px;
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    padding: 36px 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.cash-opening-screen__title {
    font-size: 28px;
    font-weight: 700;
    color: #2f3640;
    margin-bottom: 10px;
    text-align: center;
}

.cash-opening-screen__subtitle {
    font-size: 15px;
    color: #6b7280;
    text-align: center;
    margin-bottom: 26px;
}

.cash-opening-screen__field {
    width: 100%;
    max-width: 520px;
    margin-bottom: 22px;
}

.cash-opening-screen__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}
</style>
